import { useState, useEffect, useContext } from 'react'
import { useQlikScripts} from './QlikScripts'
import { QlikUIContext } from '../QlikUIContext'

export function useQlik() {

    const context = useContext(QlikUIContext);

    const [qlikLoaded, setQlikLoaded] = useState(false);
    const [qlik, setQlik] = useState();

    const [scriptsLoaded] = useQlikScripts();

    async function qlikAsync() {
        window.require.config({
          baseUrl: `${(context.qlikSecure ? 'https://' : 'http://') + context.qlikEnvironmentUrl + (context.qlikPort ? `:${context.qlikPort}` : '') + context.qlikPrefix}resources`,
          paths: {
            qlik: `${(context.qlikSecure ? 'https://' : 'http://') + context.qlikEnvironmentUrl + (context.qlikPort ? `:${context.qlikPort}` : '') + context.qlikPrefix}resources/js/qlik`,
          }
        });
        return new Promise((resolve) => {
            window.require(['js/qlik'], (qlik) => {
                resolve(qlik);
            });
        });
    }

    useEffect(() => {

        async function loadQlik() {

            const qlikApp = await qlikAsync();

            setQlik(qlikApp);
            setQlikLoaded(true);
        }

        if (scriptsLoaded) {
            loadQlik();

        }

    },[scriptsLoaded]);

    return [qlikLoaded, qlik, qlikAsync];
}